import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';

const ButtonLabel = styled.div`
  font-size: ${({ _buttonLabelFont }) => _buttonLabelFont?.fontSize}px;
  font-weight: ${({ _buttonLabelFont }) => _buttonLabelFont?.fontWeight};
  font-style: ${({ _buttonLabelFont }) => _buttonLabelFont?.fontStyle};
  line-height: ${({ _lineHeight }) => _lineHeight}px;
  font-family: ${({ _font }) => _font?.value};
`;

const ButtonSecondLine = styled.div`
  font-size: ${({ _secondLineFont }) => _secondLineFont?.fontSize}px;
  font-weight: ${({ _secondLineFont }) => _secondLineFont?.fontWeight};
  font-style: ${({ _secondLineFont }) => _secondLineFont?.fontStyle};
  font-family: ${({ _font }) => _font?.value};
`;

const ButtonInner = () => {
  const {
    font,
    buttonLabel,
    buttonSecondLine,
    buttonLabelFont,
    secondLineFont,
    lineHeight
  } = useSettings();

  return (
    <>
      {buttonLabel && (
        <ButtonLabel
          _buttonLabelFont={buttonLabelFont}
          _lineHeight={lineHeight}
          _font={font}
        >
          {buttonLabel}
        </ButtonLabel>
      )}
      {buttonSecondLine && (
        <ButtonSecondLine _secondLineFont={secondLineFont} _font={font}>
          {buttonSecondLine}
        </ButtonSecondLine>
      )}
    </>
  );
};

export default ButtonInner;
